const trimLast = (str, char) => (str.lastIndexOf(char) === str.length - 1 ? str.slice(0, -1) : str);

// Replacing global with globalThis. https://github.com/nodejs/node/issues/47784
const { SEMS = { api: '', dir: '', staticUrl: '' } } = window.globalThis;

module.exports = {
  api: SEMS.api,
  dir: trimLast(SEMS.dir, '/'),
  staticUrl: SEMS.staticUrl,
  google: {
    mapsApiKey: window.App.state.runtime.googleMapsApiKey,
  },
  // default locale is the first one
  locales: [
    /* @intl-code-template '${lang}-${COUNTRY}', */
    'en-US',
    'cs-CZ',
    'ar',
    /* @intl-code-template-end */
  ],
};
